var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 53,
    height: 38,
    viewBox: "0 0 2666.6667 2666.6667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,2000 H 2000 V 0 H 0 Z",
    id: "path14"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,2666.6667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(1842.2686,1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-465.172 -377.097,-842.269 -842.269,-842.269 -465.171,0 -842.268,377.097 -842.268,842.269 0,465.172 377.097,842.268 842.268,842.268 C -377.097,842.268 0,465.172 0,0",
    style: {
      fill: "#434de7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(1377.5176,624.9961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -761.554 c -13.435,0 -24.326,11.104 -24.326,24.803 v 145.945 l 75.028,86.156 H -42.508 L 24.327,170.748 V 24.803 C 24.327,11.104 13.436,0 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(1428.4395,1470.7173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -306.452 h -25.828 c -34.295,0 -62.117,-27.714 -62.117,-61.877 v -194.797 h -684.056 v 211.604 c 0,34.162 -27.823,61.876 -62.117,61.876 h -51.381 V 0 c 0,70.799 57.638,128.215 128.713,128.215 h 628.073 C -57.639,128.215 0,70.799 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(618.0942,1122.1792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -251.015 l -47.24,-52.362 c -10.552,-11.718 -16.411,-26.933 -16.411,-42.7 v -277.641 h -150.554 v 457.214 c 0,23.404 4.203,46.533 12.332,68.313 0.031,0.03 0.031,0.061 0.031,0.092 1.134,2.669 2.362,5.307 3.681,7.914 l 27.914,55.645 3.19,6.38 14.326,27.454 c 7.791,14.909 23.19,24.234 39.969,24.234 h 89.234 C -10.521,23.528 0,13.006 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(1381.9053,1107.9663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -249.924 l 47.973,-52.135 c 10.715,-11.667 16.666,-26.816 16.666,-42.515 v -276.434 h 152.889 v 455.226 c 0,23.304 -4.268,46.332 -12.523,68.017 -0.031,0.031 -0.031,0.061 -0.031,0.092 -1.153,2.657 -2.399,5.284 -3.739,7.88 l -28.346,55.403 -3.241,6.352 -14.546,27.335 c -7.914,14.844 -23.551,24.129 -40.59,24.129 H 23.893 C 10.685,23.426 0,12.95 0,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2a7cc7a56c1baa2ccf66cc3aab4c9e6b.svg";
export { ForwardRef as ReactComponent };